import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface FullScreenLoaderProps {
    message?: string;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({
    message = 'Cargando...'
}) => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
            }}
        >
            <CircularProgress
                size={60}
                thickness={5}
                sx={{ color: 'white' }}
            />
            <Typography
                variant="h6"
                sx={{
                    mt: 2,
                    color: 'white',
                    fontWeight: 'medium'
                }}
            >
                {message}
            </Typography>
        </Box>
    );
};

export default FullScreenLoader;